import { Injectable } from '@angular/core';
import { fromEvent, Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClickOutsideService {
  private documentClickEvent = new Subject<MouseEvent>();
  get onDocumentClick(): Observable<MouseEvent> {
    return this.documentClickEvent.asObservable();
  }
  constructor() {
    fromEvent(document, 'click').subscribe((event: MouseEvent) =>
      this.documentClickEvent.next(event)
    );
  }
}
